export default __webpack_public_path__ + "static/media/CNo.75-3.b8bf1e06.jpg";